import { Card, CardHeader } from '@thoughtspot/radiant-react/widgets/card';
import { Horizontal, Vertical, } from '@thoughtspot/radiant-react/widgets/layout';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import cx from 'classnames';
import React from 'react';
import { InputType } from '../types';
import styles from './config-card.module.scss';
import { EditOrgsCard, EditOrgsWithToggleCard, } from './edit-orgs-cards.container';
import { DoubleSelectInput } from './input-types/double-select-input';
import { InputInput } from './input-types/input';
import { SelectInput } from './input-types/select-input';
import { ToggleInput } from './input-types/toggle-input';
export const ConfigCard = props => {
    const { title, description, disabled, hide, className } = props;
    const testId = props['data-testid'];
    if (props.inputType === InputType.EditOrgs) {
        return React.createElement(EditOrgsCard, { ...props });
    }
    if (props.inputType === InputType.EditOrgsWithToggle) {
        return React.createElement(EditOrgsWithToggleCard, { ...props });
    }
    const renderInput = () => {
        switch (props.inputType) {
            case InputType.Toggle:
                return (React.createElement(ToggleInput, { title: title, checked: props.checked, onChange: props.onChange, name: props.name, disabled: disabled }));
            case InputType.Input:
                return (React.createElement(InputInput, { type: props.type, value: props.value, onChange: props.onChange, onValidationError: props.onValidationError, onFocus: props.onFocus, onBlur: props.onBlur, placeholder: props.placeholder, disabled: disabled, readOnly: props.readOnly, maxLength: props.maxLength, min: props.min, max: props.max, validation: props.validation }));
            case InputType.Select:
                return (React.createElement(SelectInput, { value: props.value, options: props.options, onChange: props.onChange, searchable: props.searchable, placeholder: props.placeholder, disabled: disabled }));
            case InputType.DoubleSelect:
                return (React.createElement(DoubleSelectInput, { first: {
                        ...props.first,
                        disabled: props.first.disabled ?? disabled,
                    }, second: {
                        ...props.second,
                        disabled: props.second.disabled ?? disabled,
                    } }));
            default:
                return null;
        }
    };
    return (React.createElement(Card, { className: cx(styles.cardWrapper, className), isTabDisabled: true, "data-testid": testId },
        React.createElement(CardHeader, { className: styles.cardHeader },
            React.createElement(Horizontal, { className: styles.cardHeaderRow, vAlignContent: "top", spacing: "b" },
                React.createElement(Vertical, { spacing: "b", grow: true },
                    React.createElement(Typography, { variant: "content-label" }, title),
                    description && (React.createElement(Typography, { variant: "body-normal", color: Colors.info, ellipsis: { rows: 2 } }, description))),
                !hide && (React.createElement("div", { className: styles.controlContainer }, renderInput()))))));
};
//# sourceMappingURL=config-card.js.map